export const broadcast = new EventTarget();

export const broadcastChannels = {
    SplitScreenChange: 0,

    PopupWrapperClick: 1,

    SocketStateChange: 2,

    NetworkTimeChange: 3,
};